/*
This contains helper methods to performance operations using keyboard
 */

import { DEFAULT_IMPACT, DEFAULT_STATUS } from '@/constants/initiative'
import { getInitiativePageRouteConfig } from '@/utils/navigationConfigs'
import * as R from 'ramda'
import * as keymapService from '@/services/keymapService/keymapService'
import scrollToElement from '@/utils/scrollToElement'
import { EVENT_ACTION, EVENT_CATEGORY, EVENT_NAME } from '@/constants/analytics'
import { trackEvent } from '@/analytics'

export default {
  methods: {
    addNewInitiative(krId) {
      let kr = this.$store.getters.keyResultById(+krId) // convert krId to number before passing to fn
      let newInitiative = {
        id: this.createInitiativeId(),
        title: '',
        impact: DEFAULT_IMPACT,
        coOwnerIds: kr && kr.coOwnerIds,
        ownerId: kr && kr.ownerId,
        isClosed: false,
        keyResultId: kr.id,
        goalId: kr.goalId,
        status: DEFAULT_STATUS
      }
      this.$emit('update-initiatives', R.append(newInitiative, this.initiatives))
    },
    getSelectedInitiativeVueComponent() {
      let selectedItem = this.$el.querySelector('.select-list-item.selected')
      if (selectedItem) {
        return selectedItem.__vue__
      }
    },
    scrollToSelectedElement() {
      const selectedElement = keymapService.selectedListItem(this.$el)
      scrollToElement(selectedElement)
    },
    selectPreviousItem(event) {
      event.preventDefault()
      keymapService.selectListItem(this.$el, 'previous')
      document.activeElement.blur()
      this.focusTabPin()
      this.scrollToSelectedElement()
    },
    selectNextItem(event) {
      event.preventDefault()
      keymapService.selectListItem(this.$el, 'next')
      document.activeElement.blur()
      this.focusTabPin()
      this.scrollToSelectedElement()
    },
    editInitiative(event) {
      event.preventDefault()
      const initiative = this.getSelectedInitiativeVueComponent()
      if (this.isTaskSelected()) {
        initiative.showActivityModal({ editInitiativeOnLoad: true })
      } else if (initiative) {
        initiative.editInitiative(event)
      }
    },
    viewItem(event) {
      const isDropdownField = event.target.classList.contains('dropdown-item')
      const isDropdownMenu = event.target.classList.contains('dropdown-menu')
      const isOwnerField = event.target.classList.contains('owner')
      const isDueDateField = event.target.classList.contains('due-date-field')
      if (![isDropdownField, isDropdownMenu, isOwnerField, isDueDateField].some(Boolean)) {
        const selectedItem = keymapService.selectedListItem(this.$el)
        const initiativeId = selectedItem.dataset.initiativeId
        const initiative = this.$store.getters.initiativeById(+initiativeId)
        const location = getInitiativePageRouteConfig({
          orgId: initiative.organizationId,
          initiativeId: initiativeId
        })
        this.$router.push(location)
      }
    },
    doneUndone(event) {
      const initiativeVue = this.getSelectedInitiativeVueComponent()
      if (
        initiativeVue &&
        (!initiativeVue.$el.contains(document.activeElement) ||
          document.activeElement.classList.contains('tab-pin'))
      ) {
        event.preventDefault() // prevent scroll
        const initiative = initiativeVue.initiative
        initiativeVue.changeIsDoneAndClosed(!initiative.isDoneAndClosed)
      }
    },
    // This prevents the passed func to get invoked if bulk selection is active
    withBulkSelectionHandler(func) {
      return (...args) => {
        const isBulkSelectionActive = this.$store.getters['bulkAction/isBulkSelectionActive']
        if (!isBulkSelectionActive) {
          func(...args)
        }
      }
    },
    triggerDeleteInitiative(event) {
      const initiativeVue = this.getSelectedInitiativeVueComponent()
      if (
        initiativeVue &&
        (!initiativeVue.$el.contains(document.activeElement) ||
          document.activeElement.classList.contains('tab-pin'))
      ) {
        event.preventDefault() // prevent scroll
        initiativeVue.triggerDeleteInitiative()
      }
    },
    toggleItem: function(expanded) {
      const selectedItem = keymapService.selectedListItem(this.$el)
      if (selectedItem) {
        let selectedItem = this.$el.querySelector('.select-list-item.selected')
        const vueNode = selectedItem.__vue__
        vueNode.expanded = typeof expanded === 'undefined' ? !vueNode.expanded : expanded
        setTimeout(() => selectedItem.classList.add('selected'), 100)
      }
    },
    expandItem(event) {
      event.preventDefault()
      this.toggleItem(true)
    },
    collapseItem(event) {
      event.preventDefault()
      this.toggleItem(false)
    },
    /**
     * This focuses the tab-pin of selected row, so that tab-key can take focus to next status checkbox
     * @returns {Vue}
     * @type {Element}
     */
    focusTabPin() {
      const selected = this.$el.querySelector('.initiative-row.selected')
      if (selected) {
        const tabPin = selected.querySelector('.tab-pin')
        tabPin &&
          tabPin.focus({
            preventScroll: true
          })
      }
    },
    /**
     * This function accepts a DOM node inside initiative row and it will return the reference of Vue component for the initiative
     * @param node
     * @returns {null|*|null|*}
     */
    getInitiativeRowVue(node) {
      if (!node) return null
      if (R.pathEq(['__vue__', '$options', 'name'], 'InitiativeRow', node)) {
        return node.__vue__
      } else return this.getInitiativeRowVue(node.parentElement)
    },
    /**
     * This can be used to take user out of edit mode of initiative
     */
    cancelInitiativeEditing() {
      const active = document.activeElement
      if (active) {
        const initiativeVue = this.getInitiativeRowVue(active)
        initiativeVue && initiativeVue.cancelInitiativeEdit()
      }
    },
    openActivityModal() {
      const initiative = this.getSelectedInitiativeVueComponent()
      if (initiative) {
        initiative.showActivityModal({ focusAddCommentOnLoad: true })
        trackEvent(EVENT_CATEGORY.NAVIGATION, EVENT_ACTION.ACTIVITY_MODAL_KB, EVENT_NAME.INITIATIVE)
      }
    },
    isTaskSelected() {
      const selectedItem = keymapService.selectedListItem(this.$el)
      return selectedItem?.classList.contains('task-row')
    },
    isInitiativeSelected() {
      const selectedItem = keymapService.selectedListItem(this.$el)
      return selectedItem?.classList.contains('initiative-row')
    },
    addInitiativeComment(event) {
      if (this.isTaskSelected()) {
        const initiative = this.getSelectedInitiativeVueComponent()
        initiative.showActivityModal(event)
      } else {
        const commentField = this.$el.querySelector('#addComment')
        commentField && commentField.click()
      }
    }
  }
}
